var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.317,
    height: 50.467,
    viewBox: "0 0 88.317 50.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop-svgrepo-com",
    transform: "translate(0 -108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160495",
    "data-name": "Path 160495",
    d: "M116.9,152.018a2.834,2.834,0,0,1-2.383,2.243H45.542c-.981,0-1.542-1.262-1.542-2.243V109.682c0-1.121.561-1.682,1.542-1.682h68.971c.981,0,2.383.561,2.383,1.682Z",
    transform: "translate(-36.29)",
    fill: "#0a4d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160496",
    "data-name": "Path 160496",
    d: "M45.542,153.841A1.632,1.632,0,0,1,44,152.018V109.682c0-1.121.561-1.682,1.542-1.682",
    transform: "translate(-36.29)",
    fill: "#106899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160497",
    "data-name": "Path 160497",
    d: "M44,109.682c0-1.121.561-1.682,1.542-1.682h69.532a1.547,1.547,0,0,1,1.682,1.682v42.336a2.248,2.248,0,0,1-2.1,1.963",
    transform: "translate(-36.29)",
    fill: "#00233f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160498",
    "data-name": "Path 160498",
    d: "M127.289,163.252V125.4c0-.981-.841-1.4-1.682-1.4H61.682A1.57,1.57,0,0,0,60,125.4v37.85Z",
    transform: "translate(-50 -13.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 0.561,
    cy: 0.561,
    r: 0.561,
    transform: "translate(43.738 108.701)",
    fill: "#27d68a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160500",
    "data-name": "Path 160500",
    d: "M252.8,112a.561.561,0,1,1,0,1.121",
    transform: "translate(-208.501 -3.299)",
    fill: "#15af83"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 0.14,
    cy: 0.14,
    r: 0.14,
    transform: "translate(43.875 108.97)",
    fill: "#cfffef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160502",
    "data-name": "Path 160502",
    d: "M0,365.6c.421,2.8,2.383,5.327,4.766,5.327H83.551c2.383,0,4.346-2.523,4.766-5.327Z",
    transform: "translate(0 -212.46)",
    fill: "#b8d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160503",
    "data-name": "Path 160503",
    d: "M86.85,369.607c2.383,0,4.346-2.523,4.766-5.327L4,364",
    transform: "translate(-3.299 -211.141)",
    fill: "#a7c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160504",
    "data-name": "Path 160504",
    d: "M88.317,357.4c0,.7-.421,1.4-.841,1.4H.841c-.421,0-.841-.7-.841-1.4H0c0-.7.421-1.4.841-1.4H87.476c.421,0,.841.7.841,1.4Z",
    transform: "translate(0 -204.542)",
    fill: "#edf4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160505",
    "data-name": "Path 160505",
    d: "M88.317,365.6h0c0,.7-.421,1.121-.841,1.121H.841C.421,366.721,0,366.3,0,365.6H0",
    transform: "translate(0 -212.46)",
    fill: "#d6e4e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160506",
    "data-name": "Path 160506",
    d: "M207.2,356c.7,1.4.7,2.8,2.243,2.8h11.215c1.542,0,1.542-1.4,2.243-2.8Z",
    transform: "translate(-170.892 -204.542)",
    fill: "#b8d2d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7635",
    "data-name": "Group 7635",
    transform: "translate(37.149 151.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160507",
    "data-name": "Path 160507",
    d: "M212,356c.561,1.4.561,2.8,1.963,2.8h9.953c1.4,0,1.4-1.4,1.963-2.8Z",
    transform: "translate(-212 -356)",
    fill: "#8db2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160508",
    "data-name": "Path 160508",
    d: "M407.875,381.641a.372.372,0,0,1-.421.421H397.221a.372.372,0,0,1-.421-.421v-.421a.372.372,0,0,1,.421-.421h10.234a.372.372,0,0,1,.421.421Z",
    transform: "translate(-364.417 -376.454)",
    fill: "#8db2b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_160509",
    "data-name": "Path 160509",
    d: "M407.875,385.6h0a.372.372,0,0,1-.421.421H397.221a.372.372,0,0,1-.421-.421h0",
    transform: "translate(-327.268 -228.956)",
    fill: "#7aa09f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "yagna-ritual-svgrepo-com",
    transform: "translate(27 77.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160489",
    "data-name": "Path 160489",
    d: "M157.816,54.332a6.266,6.266,0,0,1-1.5-2.982,6.427,6.427,0,0,1,.259-3.37c.747-2.088,2.224-2.646,3.831-4.465a13.4,13.4,0,0,0,2.766-5.125.263.263,0,0,1,.365-.161,7.784,7.784,0,0,1,1.73,1.138,8.619,8.619,0,0,1,2.6,8.065l-.418,1.037h0l2.183-3.114a.263.263,0,0,1,.467.073,9.812,9.812,0,0,1-.418,7.477,8.442,8.442,0,0,1-.935,1.427",
    transform: "translate(-145.632)",
    fill: "#ffdb6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160490",
    "data-name": "Path 160490",
    d: "M203.609,135.7a.281.281,0,0,0-.5-.087l-.785,1.12c-.05.072-.092-.021-.069-.154a5.257,5.257,0,0,0-1.488-4.617,4.435,4.435,0,0,0-.9-.6.235.235,0,0,0-.332.138,7.632,7.632,0,0,1-1.555,2.84c-.92,1.041-1.765,1.361-2.193,2.556a3.679,3.679,0,0,0-.148,1.929c.017.085.037.167.06.249a4.03,4.03,0,0,0,3.6,3.271,4.443,4.443,0,0,0,3.991-2.629A4.958,4.958,0,0,0,203.609,135.7Z",
    transform: "translate(-182.343 -86.828)",
    fill: "#fa6657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7633",
    "data-name": "Group 7633",
    transform: "translate(0 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160491",
    "data-name": "Path 160491",
    d: "M34.078,412.527H.557A.556.556,0,0,1,0,411.97v-2.581a1.308,1.308,0,0,1,1.308-1.308H33.326a1.308,1.308,0,0,1,1.308,1.308v2.581A.557.557,0,0,1,34.078,412.527Z",
    transform: "translate(0 -399.19)",
    fill: "#d65a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160492",
    "data-name": "Path 160492",
    d: "M79.235,347.67H51.579v-4a1.308,1.308,0,0,1,1.308-1.308h25.04a1.308,1.308,0,0,1,1.308,1.308v4h0Z",
    transform: "translate(-48.09 -337.915)",
    fill: "#d65a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160493",
    "data-name": "Path 160493",
    d: "M118.995,281.953H97.559v-4a1.308,1.308,0,0,1,1.308-1.308h18.819a1.308,1.308,0,0,1,1.308,1.308v4Z",
    transform: "translate(-90.96 -276.643)",
    fill: "#d65a4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7634",
    "data-name": "Group 7634",
    transform: "translate(0 56.963)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 27.654,
    height: 1.815,
    transform: "translate(3.489 4.446)",
    fill: "#953a3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160494",
    "data-name": "Path 160494",
    d: "M.557,448.787H34.078a.557.557,0,0,0,.557-.557v-1.258H0v1.258A.557.557,0,0,0,.557,448.787Z",
    transform: "translate(0 -438.08)",
    fill: "#953a3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3277",
    "data-name": "Rectangle 3277",
    width: 21.431,
    height: 1.815,
    transform: "translate(6.6)",
    fill: "#953a3c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ecd869891df3289de61faa4ee09c273f.svg";
export { ForwardRef as ReactComponent };